module.exports = "<div class=auto-select-component> <input class=result readonly=readonly placeholder={{placeholder}}> <div class=triangle></div> <div class=list> <div class=auto-select-text-wrap> <input class=auto-select-text type=text placeholder=选择或者输入查找 /> </div> <ul class=auto-select-ul> </ul> <div class=select-all> <a>全选</a> 已选<span>0</span>项 </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/util/autoSelect/autoSelect.html
// module id = 1943
// module chunks = 50